module.exports = __webpack_public_path__ + "static/media/clock.00cec16e.png";